import { render, staticRenderFns } from "./addproduct.vue?vue&type=template&id=094f1393&scoped=true"
import script from "./addproduct.vue?vue&type=script&lang=js"
export * from "./addproduct.vue?vue&type=script&lang=js"
import style0 from "./addproduct.vue?vue&type=style&index=0&id=094f1393&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094f1393",
  null
  
)

export default component.exports